<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           $_em-custom-vuex-mixin_vo="productsVo"
                                           $_em-custom-vuex-mixin_filter="productsFilter"
                                           query-api="productsInputQuery"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryStorageInputResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      $_em-custom-vuex-mixin_vo="productsVo"
                                      $_em-custom-vuex-mixin_filter="productsFilter"
                                      $_em-custom-vuex-mixin_entity="productsEntity"
                                      query-api="productsInputQuery"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button
                                        type='search'
                                        class="btn btn-outline-primary btn-sm"
                                        custom-label="扫码识别"
                                        showName
                                        @click="openScannerDialog()"
                                    >
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-warehouse"
                                               :disabled="actionDisabled('selectOne')"
                                               custom-label="实入上BIN"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="openInputDialog()"
                                    >
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="入库" width="30%" :visible.sync="storageInputDialogVisible" :close-on-click-modal='false'
                   append-to-body @close='clearInputForm'>
            <el-form :model="inputForm" ref="inputForm" label-width="auto" size="mini" :rules="rules">
                <!-- <el-form-item label="库房" prop="storageId">
                    <el-select v-model="inputForm.storageId" placeholder="请选择">
                        <el-option v-for="storage in storageOptions" :key="storage.id" :label="storage.name" :value="storage.id"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="Storage Type" prop="storageType">
                    <el-input v-model="inputForm.storageType"></el-input>
                </el-form-item>
                <el-form-item label="BIN位" prop="binCode">
                    <el-input v-model="inputForm.binCode"></el-input>
                </el-form-item>
                <el-form-item label="BIN位已占容量" prop="binOccupiedCapacity">
                    <el-input v-model="inputForm.binOccupiedCapacity"></el-input>
                </el-form-item>
            </el-form>
            <el-dialog title="扫一扫" :center="true" :visible.sync="binScannerVisible" append-to-body
                       @close="closeBinScanner" :close-on-click-modal='false'>
                <qr-code-scanner ref="binScanner" @getCodeData='getBinInfo'>
                </qr-code-scanner>
            </el-dialog>

            <div slot="footer" class="dialog-footer">
                <el-button @click="openBinScanner()">扫描BIN位码</el-button>
                <el-button @click="storageInputDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="storageInput()">确认入库</el-button>
            </div>
        </el-dialog>
        <el-dialog title="扫一扫" :center="true" :visible.sync="scannerVisible" append-to-body
                   @close="closeScannerDialog" :close-on-click-modal='false'>
            <qr-code-scanner ref="inputScanner" @getCodeData='getInputTask'>
            </qr-code-scanner>
        </el-dialog>
    </div>
</template>
<script>
// Author Lin
// Date 2021-07-20 17:49:21

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import emCustomVuexMixin from "@/mixin/em/customVuex";

export default {
    name: "sithMesInventoryStorageInputListView",
    mixins: [emCommonListMixin, emCommonApiMixin, emCustomVuexMixin],
    components: {qrCodeScanner},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            storageInputDialogVisible: false,
            storageOptions: [],
            inputForm: {
                storageId: '',
                binCode: '',
                binOccupiedCapacity: '',
                storageType: '',
            },
            rules: {
                storageType: [{required: true, message: '请输入StorageType'}],
                binCode: [{required: true, message: '请输入BIN位'}],
                binOccupiedCapacity: [{required: true, message: '请输入BIN容量'}]
            },
            scannerVisible: false,
            binScannerVisible: false,
        }
    },
    computed: {
        modelName() {
            return "sithMesInventoryStorageInput";
        },
        checkedItems() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItemsProductsVo"];
        },
        selectIds() {
            //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
            return this.$store.state[this.modelName]["checkedItemsProductsVo"].join(",");
        },
    },
    methods: {
        initFilter() {
            let queryStartDate = new Date();
            let queryEndDate = new Date();

            queryStartDate.setHours(0, 0, 0, 0);
            queryEndDate.setHours(23, 59, 59, 999);
            // 获取当前日期的时间戳
            let currentTime = queryStartDate.getTime();
            // 计算 30 天前的日期
            let sevenDaysAgo = currentTime - (30 * 24 * 60 * 60 * 1000);
            // 设置查询开始日期为 30 天前
            queryStartDate.setTime(sevenDaysAgo);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('inputApplyTimeRteFilter', queryStartDate.getTime());
            //this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('inputApplyTimeLteFilter', queryEndDate.getTime());
        },
        actionDisabled(type) {
            // 删除按钮在一条记录都没选的时候禁用
            if (type === "select") {
                return this.checkedItems && this.checkedItems.length === 0;
            }
            // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
            else if (type === "selectOne") {
                return this.checkedItems && this.checkedItems.length !== 1;
            }
        },
        openInputDialog() {
            this.storageInputDialogVisible = true;
        },
        clearInputForm() {
            this.inputForm.storageId = '';
            this.inputForm.binCode = '';
            this.inputForm.binOccupiedCapacity = '';
            this.inputForm.storageType = '';
            this.$refs.inputForm.resetFields();
        },
        getStorageOptions() {
            this.$_emApiMixin_findByFilter("sithMesInventoryWmDefinition", {})
                .then(data => {
                    this.storageOptions = data.map(m => {
                        return {id: m.id, name: m.warehouseNo}
                    })
                })
        },
        storageInput() {
            let self = this;
            self.$refs["inputForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryStorageInput")}/confirmInput?ids=${this.selectIds}`
                    self.$_emApiMixin_post(url, self.inputForm)
                        .then((request) => {
                            if (request.status === 200) {
                                self.$message({
                                    message: "入库结束",
                                    type: "success",
                                });

                                self.$refs.emListFilter.doQuery();
                            } else {
                                self.$message({
                                    message: "入库失败",
                                    type: "error",
                                });
                            }
                        }).finally(() => {
                        this.storageInputDialogVisible = false;
                    })
                }
            })
        },
        openScannerDialog() {
            this.scannerVisible = true;
            setTimeout(() => {
                this.$refs.inputScanner.openCamera('');
            }, 500);
        },
        openBinScanner() {
            this.binScannerVisible = true;
            setTimeout(() => {
                this.$refs.binScanner.openCamera('');
            }, 500);
        },
        getInputTask(data) {
            console.log("get qr code data:" + data);
            this.scannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var materialCode = obj['物料号'];
                // var orderCode = obj.orderCode;
                console.log(materialCode);
                // console.log(orderCode);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            // this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('orderCodeFilter', orderCode);
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialCodeFilter', materialCode);
            this.$refs.emListFilter.doQuery();
        },
        getBinInfo(data) {
            console.log("bin code data:" + data);
            this.binScannerVisible = false;
            let self = this;
            //检验二维码的数据格式
            try {
                var obj = JSON.parse(data);
                var storageType = obj['Storage Type'];
                var storageBin = obj['Storage Bin'];
                console.log(storageType);
                console.log(storageBin);
            } catch (error) {
                self.$message({
                    message: "无效的二维码",
                    type: "error",
                });
                return;
            }
            self.inputForm.storageType = storageType;
            self.inputForm.binCode = storageBin;
        },
        closeScannerDialog() {
            this.$refs.inputScanner.closeCamera();
            this.$refs.inputScanner.resetOutputData();
            this.scannerVisible = false;
        },
        closeBinScanner() {
            this.$refs.binScanner.closeCamera();
            this.$refs.binScanner.resetOutputData();
            this.binScannerVisible = false;
        },
    },
    mounted() {
        if (this.$route.query.hasOwnProperty("id")) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
            this.$refs.emListFilter.doQuery();
        } else {
            this.initFilter();
        }
        // this.getStorageOptions();
    },
};
</script>
